var _defs, _text, _text2, _text3, _polygon, _polygon2, _text4, _text5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _rect, _polygon3, _text6, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 617.43 444.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-1,.cls-17{fill:#231f20;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{font-size:40.84px;font-family:ProximaNova-Black, Proxima Nova;font-weight:800;}.cls-20,.cls-4,.cls-9{fill:#fff;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:-0.06em;}.cls-7{letter-spacing:-0.01em;}.cls-8{letter-spacing:-0.01em;}.cls-9{font-size:10.83px;}.cls-21,.cls-9{font-family:ProximaNova-Regular, Proxima Nova;}.cls-10{letter-spacing:0em;}.cls-11{letter-spacing:-0.07em;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:-0.01em;}.cls-15,.cls-21{fill:#812990;}.cls-16{fill:#6b7b84;}.cls-18,.cls-19{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-18{stroke:#ffcb05;}.cls-19{stroke:#6b7b84;}.cls-21{font-size:6.43px;}.cls-22{letter-spacing:-0.02em;}.cls-23{letter-spacing:-0.03em;}.cls-24{letter-spacing:-0.02em;}.cls-25{letter-spacing:-0.01em;}.cls-26{letter-spacing:-0.01em;}.cls-27{letter-spacing:-0.05em;}.cls-28{letter-spacing:-0.04em;}.cls-29{letter-spacing:0em;}.cls-30{letter-spacing:-0.01em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 81.12,
    y1: 67.62,
    x2: 243.1,
    y2: 67.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.13,
    y1: 280.22,
    x2: 293.71,
    y2: 280.22,
    xlinkHref: "#linear-gradient"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0.12 442.19)"
  }, "Front")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(323.72 442.19)"
  }, "Back")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(549.6 442.19)"
  }, "Size: 14.5cm x 21cm")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "243.1 0.13 162.11 135.12 81.12 0.13 243.1 0.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "293.71 135.12 162.11 135.12 0.13 405.09 0.13 425.32 293.71 425.32 293.71 135.12"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(101.36 311.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 24.22,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.07,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 75.06,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.34,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 34.03
  }, "SMA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 90.79,
    y: 34.03
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 118.07,
    y: 34.03
  }, "T"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(101.36 384.83)"
  }, "EDU", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 21.34,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 28.63,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.03,
    y: 0
  }, "TION \u2022 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 69.23,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 76.52,
    y: 0
  }, "AREER \u2022 VI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 128.37,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.61,
    y: 0
  }, "A"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M56.3,158.73l-1,.14a3.42,3.42,0,0,1-.48.11c-.38,0-.58-.48-1.11-.58-.13,0,0,0-.19-.07s.06,0-.25-.12c0,.35-.08.25-.08.52a2,2,0,0,0,.22.9c.1.19.14.12.13.4a1.86,1.86,0,0,0,.15,1.13,2.65,2.65,0,0,1,.39.79c.52,0,.45,0,.51.15.49,0,.17-.1.44-.15,0,0,.5.12.37-.5.37.09.2.29.43.27s.1-.19.13-.41-.09-.07.25-.23l-.07-.44c0-.52.12,0,.29.07l.22-1.55c0-.12.16-.06-.15-.51C56.18,158.7,56.37,158.71,56.3,158.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M56.44,157.42c-.06.2.12.11-.14.14l.29.65c.13-.06.09-.05.29-.06,0-.45,0-.29-.15-.52S56.63,157.46,56.44,157.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.76,156.82c-.07.3,0,0-.1.24s-.13.66.32.42C53,157,53,157,52.76,156.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.09,151.61a2.93,2.93,0,0,0-.9.14c-.54.14-.3.26-.12.52a3.24,3.24,0,0,0,1.27-.18c.24,0,.26,0,.12-.26h-.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M62,148a1.82,1.82,0,0,0-.07-.25l-.84-.31-1.78-.68c-.52-.21-1.2-.49-1.87-.83s-1.43-.72-2.17-1.18a5,5,0,0,1-1.79-2,7.22,7.22,0,0,1-.4-1h-.14a4.14,4.14,0,0,0-.81.11l-.76.19a9.94,9.94,0,0,1-2,.39l-.27,0-.78,0a5.22,5.22,0,0,1-.58,0,10.76,10.76,0,0,1-1.23-.23L46,142.1a4,4,0,0,1-.33.39,1.49,1.49,0,0,1,.53,1.66,2.21,2.21,0,0,1-1.92,1.41c-.24,0-.47,0-.7,0h-.12a2.34,2.34,0,0,1-1.89-1.24,1.67,1.67,0,0,1,.14-1.84l0-.06c.09-.15.2-.3.3-.45a6.08,6.08,0,0,0,.35-.54l.18-.39a2.52,2.52,0,0,1-2.11-1.6,5.14,5.14,0,0,1-.33-1.54l-.21.06-.34.08a2.42,2.42,0,0,1-.29.32,1.86,1.86,0,0,1-1.31.62,1.63,1.63,0,0,1-.52-.09H37.4a1.7,1.7,0,0,1-1-.31,1.24,1.24,0,0,1-.8-1.48,4.63,4.63,0,0,1,.85-1.82l.1-.14a1.71,1.71,0,0,1,.51-1c.22-.22.45-.42.67-.6l.18-.15a2.84,2.84,0,0,1,.36-.29,2.23,2.23,0,0,1,.36-1,4,4,0,0,1,1.21-1.18,8.56,8.56,0,0,1,.75-.44l.37-.21a3.79,3.79,0,0,0,.34-.2l.2-.13a1.14,1.14,0,0,1,1-.06,1.15,1.15,0,0,1,.64,1.33l-.37,1.28a3,3,0,0,1-.54,1,9.35,9.35,0,0,1,.79.54,6.05,6.05,0,0,1,.63.59h.48l.16,0a4.32,4.32,0,0,0,1.17-.54l.16-.09a9.91,9.91,0,0,1,2.29-1.1,16,16,0,0,1,4.07-.57h.54c.75,0,1.51,0,2.21.07a14.14,14.14,0,0,1,1.68.23,9.9,9.9,0,0,1,4.07,1.77.76.76,0,0,0-.4-.57c-.22-.1-.11,0-.26-.13l0,0-.17-.13c-.25-.16-.21,0-.31-.36l-.1.06,0,0c-.16,0-.11-.29-.26-.47s.07.14-.31-.06c-.21-.1,0,0-.12-.08a.31.31,0,0,0-.15-.08l-.13,0c-.61-.25-.5-.35-.5-1-.52-.14-.21-.54-.17-.88.06-.53-.26-.6-.13-1.18-.73,0-.44-.72-.64-1.5l0-.71c0-.15,0,.06.08-.21l-.19-.09c-.69-.41-.55-.74-.76-.87l-.51.17c-.15.1,0,.07-.23.13-.48-.46-.25-1.41-.42-2-.06-.26-.12-.61-.46-.7a1.13,1.13,0,0,1,.21-.44c-.17-.09-.26-.07-.43-.15a2.09,2.09,0,0,0-.23-1.18c-.14-.24,0-.26-.36-.29-.09.34-.06.14-.37.29a2.1,2.1,0,0,1-.27,1.13s0,0,0,0l-.07.08a1.44,1.44,0,0,0-.3.72h.22c0,.34,0,.14-.17.35s-.08,0,0,.37-.26.41-.23.82.12.18.11.44-.07.21-.06.42c0,.55.22.41,0,.94s-.16,1.07-.49,1.62a5.93,5.93,0,0,0-.38.8,1.09,1.09,0,0,1-.83.33,3.48,3.48,0,0,1-.75-.37c-.14-.08-.25-.12-.32-.26s0-.1-.08-.22c-.17-.36-.66-.33-1-.46s-.47-.62-1.32-1l-.44-.14a3.14,3.14,0,0,1-.35-.24L46,127c-.08-.07-.24-.16-.34-.25l-.32-.19c-.29-.16-.25,0-.26-.41.16,0,.35-.36.49-.55s0,0,.09-.13l.06-.16s0,0,0,0,.11-.27.15-.37c-.3-.12,0,0-.29-.08.12-.17.09-.07.15-.29.38-.18.28-.07.51,0,.44-.64.19-.23.28-.61s.31-.39.46-.63l-.27-.17c-.31-.16-.24.12-.24-.42a1.42,1.42,0,0,0-.6.44c-.07-.1-.07.15-.07-.21a1.59,1.59,0,0,1-.37.14c.22-.28.12,0,.23-.3a1.93,1.93,0,0,0-1,.37c-.18-.13-.29-.12-.36-.37-.37,0-.1.06-.44.16a1.74,1.74,0,0,0-.59-.31v-.14c-.39,0-.65.25-1-.13,0,0-.16-.26-.19-.31-.27.08-.15.08-.37.22a.55.55,0,0,0-.32-.41c-.12-.08,0,0-.15-.06l-.41,0c-.06,0,.1,0-.22.06v.23c.28.06,0,0,.2.08l.06,0s0,0,0,0c.22.09.24,0,.59,0a1.93,1.93,0,0,1,.14.67l-.54.18,0,0-.66.08c-.28,0-.18-.07-.29-.28L40,123l-.19.11c-.21.16.11.07-.25.19a.61.61,0,0,1-.33,0c0,.19,0,.18-.16.42s0,.21-.36.25c0,.52,0,.22.15.58l-.24.08c-.37.09-.19.09-.32.46s-.32.1-.47.78c.24.17.29.17.34.32a.63.63,0,0,1,0,.27c-.7-.06-.39,0-.65,0a2.89,2.89,0,0,0-.82-.12c0,.53,0,.17-.15.31l0,0-.1.17c0-.5.1-.15.14-.58-.62-.17-.6-.83-1.23-.94s0-.15-.54-.16c-.13.27,0,.32-.29.51.08-.35.05-.11,0-.22-.27.07-.16.08-.37.22,0-.34-.08-.28-.36-.14,0,.21,0,.15.21.21a1,1,0,0,0-.15.44l-.43-.36c-.2.38,0,.25-.28.45l-.1.06a1.43,1.43,0,0,0-.22.15c.11.4.2.07.08.36-.25,0-.27.11-.44.34l0,0,0,.06a1.2,1.2,0,0,1-.12.11c-.11.1-.24.14-.27.37a.69.69,0,0,0,.18.42c-.16.19-.14.13-.15.44l-.32-.11c-.34-.07-.16.19-.26-.11h-.37c0,.5-.18.38-.08.6s.28.18.45.43c-.19.07-.07,0-.29,0,0,.39.08.13,0,.52-.23-.17-.11-.12-.37-.6s-.27-.16-.23-.65c-.3.08-.28.23-.43.44l-.36.38a1.23,1.23,0,0,0-.29.58c0,.21.13.33.13.72.05,0,0,0,0,.05l.2-.05c-.05.16,0,.09-.11.19l-.07.08c-.11.12,0,0-.12.11l-.12.09,0,0-.09.06c-.18.15-.14.17-.22.37l0,.09c-.45,1.17-.72,1.17-2,1.66-.25.09,0,.06-.27.08s-.19-.17-.5,0-.05.18-.29.37-.42-.12-1.11.58a.6.6,0,0,1-.46.18c-.37,0-.09-.21-.58.11,0-.39.08-.14-.14-.22-.07.23-.06.19-.25.34-.44.34-.09-.1-.72.6l-.08.08-.23.28-.06.09c-.35.39-1.1.22-1.1,1.4H21a5.39,5.39,0,0,1-.08-.81,1.7,1.7,0,0,0-.52,1.32c.24.08.07-.12.2.18a1,1,0,0,1-.06.9,1.74,1.74,0,0,0-.14.4V140c0,.17.07.12.24.32s.06.27.38.65l0,0c.09.11.1.14.19.26.29.38.41.19.41,1.06h-.15a1.2,1.2,0,0,0-.81-1c0,.68.18.23.22.73-.17-.1-.07-.08-.29-.14,0,.38.07.13-.15.22.48.71,1.22,1,1.41,1.9.07.41.5.62.66,1,.08.19,0,0,.11.23s.15.13.23.22a1,1,0,0,1,.25.64c.25,1.55,1.19,1.87,1.29,2.8v.55c-.06.32,0,.27.12.59s-.05.43-.11.68a1.71,1.71,0,0,1-.43-.06c0,.52,0,1,.45,1s.83.75,1.85.58a3.89,3.89,0,0,0,1.13-.14c.29-.17.32-.34.43-.46l0,0,.11-.11.06-.08.22-.13c.17,0,.44,0,.52-.26,0,0,0-.12,0-.14.11-.41.69-.4,1.07-.53l.85-.11h.17c.27,0-.08,0,.19,0l.11,0,0,0c.26.12-.19.06.27.09.07-.16.16-.24.62-.23s.86.22,1.09-.77a.88.88,0,0,1,.14-.38c.19-.21.31-.11.6-.29,1.17-.68.71-.79,2-.82a3.74,3.74,0,0,0,1.41-.43c.86-.34.78-.59,2.12-.59a3.07,3.07,0,0,0,.84-.12c.33,0,1,.46,1.23.63.42-.11.19-.31.71,0a2.58,2.58,0,0,0,.9.2c.1.23,0,0,0,.37.24,0,.24-.1.44,0-.06.16-.14.11-.18.27l.15.42c.18.16.32,0,.51.23s.12.31.39.64a1.2,1.2,0,0,1,.23.71h-.06l0,0-.19.19c.45,0,.33.32.73.42a.4.4,0,0,1,.15,0s0,0,.15.07l0-.29c-.06-.23,0-.3.43-.8.27-.35.78-.35,1-.72a1.68,1.68,0,0,1,.33-.55c.18-.2.05.07.16-.21,0,.05,0,0,0,0l.07.09.12.17c-.22,0-.19,0-.3.14.16.34.17.29,0,.5a1.66,1.66,0,0,0-.36,1.15c0,.43-.1.34-.51.34-.07.27-.12.2-.15.51a1.41,1.41,0,0,0,.51-.15c.32-.07.35.18.52-.21l.3-.89.14.23s0,0,0,0l0,.1a.08.08,0,0,1,0,0c.42.83-.27.86-.31,1.34a2.31,2.31,0,0,0,.74-.14s0,0,0,0,0,0,0,0c.46.39.94.9.74,1.57,0,0,0,0,0,0l0,.37a1.17,1.17,0,0,0,.31.46l.3.5c.23.25.56.14.82.43l.21.24c.22-.08.22-.17.44-.1l.17.06.06,0c.2.06.1,0,.28.09s.75.42.81.58c.41,0,1.2-1,1.4-.29.37,0,.38-.26.67-.29l-.05.1c-.1.21-.06-.13-.1.27l.34.31.11.11.23.08a.59.59,0,0,1,.13.31.37.37,0,0,0,.22-.52c.86,0,1.11-.86,2-.83.59,0,1.06.2,1.49-.14l.15-.21c.11-.25,0-.32.05-.55l.39-1.06a1.4,1.4,0,0,1,.78-1c.21-.19.05-.06.07-.2v-.05l0-.19a1.65,1.65,0,0,1,.4-.71c.44-.35.25-.6.9-1.3l.42-.24.06,0,.15-.11C62.18,149,62.09,148.51,62,148Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M29.6,130.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M43.16,135.61a10.12,10.12,0,0,0-.74-.73,12.35,12.35,0,0,0-1.14-.74,2.16,2.16,0,0,0-.57-.21.94.94,0,0,0-.36,0,2.68,2.68,0,0,1,.61-.69,2.09,2.09,0,0,0,.81-1.09c.13-.42.25-.85.38-1.28l0,0-.56.35c-.36.21-.73.39-1.07.61a3,3,0,0,0-.89.86,1.24,1.24,0,0,0-.18.9c0,.21-.1.22-.1.22a1.46,1.46,0,0,0-.65.38c-.27.23-.54.45-.79.7a.63.63,0,0,0-.19.39,1.23,1.23,0,0,1-.31.66,3.59,3.59,0,0,0-.65,1.4q-.06.25.24.21a.52.52,0,0,0,.59.22s.06,0,.08,0c.38.18.56.15.92-.19a2.09,2.09,0,0,0,.24-.28c.18-.27.47-.29.74-.36a2.23,2.23,0,0,0,.9-.37s.2-.17.3,0a2.67,2.67,0,0,1,.36.47,2.39,2.39,0,0,1,.17.7,4.19,4.19,0,0,0,.26,1.34,1.44,1.44,0,0,0,1.67.89,2.78,2.78,0,0,1,1.46,0l.28.12-.54-.05c-.09,0-.14,0-.18.12-.26.6-.51,1.21-.8,1.8-.2.38-.48.71-.7,1.08-.14.22-.34.47-.17.73a1.26,1.26,0,0,0,1,.72l.75,0a1.18,1.18,0,0,0,.87-.64.43.43,0,0,0-.11-.41.37.37,0,0,1-.38.23.91.91,0,0,0-.25.11c0-.16.16-.16.3-.21l0-.31s-.07,0-.08.05c-.16.21-.24.24-.49.16l-.2-.06c-.22-.07-.26,0-.28.17a1,1,0,0,1,0,.16.45.45,0,0,1,0-.58c.27-.34.55-.68.85-1a11.74,11.74,0,0,0,1.73-2.3,1.59,1.59,0,0,0,.16-.43.83.83,0,0,0-.4-.86,7.49,7.49,0,0,0-1-.63.72.72,0,0,1-.44-.86l.09.28c.08.26.32.34.53.45s.68.33,1,.52a1,1,0,0,1,.33,1.62c-.19.28-.36.57-.53.86-.06.11-.07.17.09.2.59.11,1.18.27,1.77.34a10,10,0,0,0,1.45,0,15.57,15.57,0,0,0,2.63-.56,4.05,4.05,0,0,1,1.55-.09s.07,0,.11,0l-.09-.82c0-.23,0-.46-.07-.69a5.59,5.59,0,0,0-.54-2.24c-.07-.12-.15-.23-.24-.36a1.49,1.49,0,0,1,.51.45,2.66,2.66,0,0,1,.41,1.12c.13.67.22,1.35.33,2a7.81,7.81,0,0,0,.61,2.12,3.87,3.87,0,0,0,1.39,1.58A21.89,21.89,0,0,0,57.93,145c.58.29,1.18.55,1.79.79s1.51.58,2.27.86l1.09.4a.64.64,0,0,1,.44.42l-.6-.3,0,0c.06.21.13.42.18.63.11.57.21,1.14.31,1.72s.15.89.21,1.34c0,.24,0,.49,0,.74a1.59,1.59,0,0,0,.35,1,2.5,2.5,0,0,0,.24.22,7.67,7.67,0,0,1,1.27,1.57,1.26,1.26,0,0,0,.45.41h.36s0-.08,0-.1a.42.42,0,0,1,0-.56,1.67,1.67,0,0,0,.16-.4c0-.24-.12-.41-.24-.59L66,153l-.3.39,0,0a.68.68,0,0,0,.1-.78,1.2,1.2,0,0,0-.49-.67,1.2,1.2,0,0,1-.57-1c-.08-.51-.13-1-.19-1.54a5.45,5.45,0,0,1-.06-.9c0-.44.09-.87.12-1.31a1,1,0,0,0-.26-.7,6.17,6.17,0,0,0-1.2-.9c-.76-.52-1.52-1-2.24-1.61a10.38,10.38,0,0,1-2.46-2.82,3.24,3.24,0,0,1-.42-1.26,2.1,2.1,0,0,1,.14-1.05,4.44,4.44,0,0,0,.25,1.84c.39-.1.75-.25.81-.69a2.57,2.57,0,0,0,0-.78c0-.25.08-.39.33-.34a1.18,1.18,0,0,1,.75.59c.61.89,1.19,1.81,1.77,2.72.36.56.71,1.12,1.08,1.66.5.73,1,1.46,1.53,2.16a13.58,13.58,0,0,0,.93,1.08c.29.31.6.61.91.91a11.92,11.92,0,0,0,4.79,2.73c.69.18,1.4.34,2.1.45a9.46,9.46,0,0,0,1.76.11A11.8,11.8,0,0,0,77,151a10.51,10.51,0,0,0,2.78-.95c.42-.22.82-.49,1.23-.74a.2.2,0,0,0,.08-.08c0-.09,0-.19,0-.28a.69.69,0,0,0-.24,0c-.22.08-.44.18-.65.28a13.12,13.12,0,0,1-2.37.85,11.59,11.59,0,0,1-1.64.32,13.82,13.82,0,0,1-1.82,0,7.58,7.58,0,0,1-3.12-.89,9,9,0,0,1-2.1-1.46c-.24-.22-.48-.44-.71-.67a16.06,16.06,0,0,1-1.66-2,30.67,30.67,0,0,1-1.76-2.9c-.4-.72-.78-1.45-1.18-2.17a20,20,0,0,0-1.91-3,12.14,12.14,0,0,0-1.51-1.61,8.57,8.57,0,0,0-4.18-2,11.19,11.19,0,0,0-1.54-.21c-.88,0-1.77-.09-2.65-.07a14.6,14.6,0,0,0-3.78.52A10.1,10.1,0,0,0,46.09,135a5.38,5.38,0,0,1-1.49.66,2.87,2.87,0,0,1-.41,0,6.47,6.47,0,0,0-.88,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M139.69,124h-.6v1.68h-.34V124h-.6v-.35h1.54Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M141.86,123.63v2h-.35v-1.44l-.67,1-.66-1v1.44h-.35v-2h.38l.63,1,.64-1Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M86.33,128.89v.65a4.35,4.35,0,0,0-1.15-.62,4.27,4.27,0,0,0-1.49-.25A4.5,4.5,0,0,0,82,129a4.23,4.23,0,0,0-1.38.92,4.11,4.11,0,0,0-.91,1.37,4.39,4.39,0,0,0,0,3.34,4.11,4.11,0,0,0,.91,1.37,4.23,4.23,0,0,0,1.38.92,4.49,4.49,0,0,0,1.74.33h.17a4.67,4.67,0,0,0,1.76-.33v-2.32h0a2.49,2.49,0,0,1-.81.52,2.66,2.66,0,0,1-.94.17l-.4,0h0a3.41,3.41,0,0,1-.55-.14,2.35,2.35,0,0,1-.8-.52,2.17,2.17,0,0,1-.72-1.64,2.22,2.22,0,0,1,.72-1.67,2.64,2.64,0,0,1,.8-.5,2.55,2.55,0,0,1,1-.18,2.46,2.46,0,0,1,1.75.68,2.22,2.22,0,0,1,.72,1.67v4.28h2.06v-8.37Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M77.62,137.26l-4.57-4.4v4.4H71v-11.6h2.06v4.39l4.57-4.37h2.91l-6,5.77,6,5.81Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M93.74,128.67a3.77,3.77,0,0,1,1.53.31,3.41,3.41,0,0,1,1.18.83A3.67,3.67,0,0,1,97.2,131a4.08,4.08,0,0,1,.27,1.5v4.72H95.41v-4.72a1.75,1.75,0,0,0-.6-1.36,2.1,2.1,0,0,0-2.83,0,1.8,1.8,0,0,0-.59,1.36v4.72h-2V128.9h2v.62a4.19,4.19,0,0,1,1-.61A3.38,3.38,0,0,1,93.74,128.67Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121.65,128.9a3.79,3.79,0,0,1,1.39-.24v2a2.47,2.47,0,0,0-1.76.69,2.28,2.28,0,0,0-.72,1.66v4.3h-2v-8.37h2v.63A4.82,4.82,0,0,1,121.65,128.9Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127.69,128.67a4.73,4.73,0,0,1,1.77.34,4.49,4.49,0,0,1,1.44.92,4.27,4.27,0,0,1,1,1.37,4.16,4.16,0,0,1,0,3.34,4.27,4.27,0,0,1-1,1.37,4.49,4.49,0,0,1-1.44.92,4.72,4.72,0,0,1-1.77.33,4.64,4.64,0,0,1-3.21-1.25,4.24,4.24,0,0,1-1-1.37,4.05,4.05,0,0,1,0-3.34,4.24,4.24,0,0,1,1-1.37,4.71,4.71,0,0,1,3.21-1.26Zm0,2a2.48,2.48,0,0,0-1.75.68,2.22,2.22,0,0,0-.72,1.67,2.17,2.17,0,0,0,.72,1.64,2.35,2.35,0,0,0,.8.52,2.75,2.75,0,0,0,1,.17,2.71,2.71,0,0,0,.95-.17,2.56,2.56,0,0,0,.8-.52,2.17,2.17,0,0,0,.72-1.64,2.22,2.22,0,0,0-.72-1.67A2.53,2.53,0,0,0,127.69,130.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137.33,128.67a4.66,4.66,0,0,1,3.21,1.26,4.43,4.43,0,0,1,1,1.37,4.16,4.16,0,0,1,0,3.34,4.43,4.43,0,0,1-1,1.37,4.8,4.8,0,0,1-5,.92,4.49,4.49,0,0,1-1.44-.92,4.27,4.27,0,0,1-1-1.37,4.16,4.16,0,0,1,0-3.34,4.27,4.27,0,0,1,1-1.37,4.49,4.49,0,0,1,1.44-.92A4.73,4.73,0,0,1,137.33,128.67Zm0,2a2.46,2.46,0,0,0-1.75.68,2.22,2.22,0,0,0-.72,1.67,2.17,2.17,0,0,0,.72,1.64,2.26,2.26,0,0,0,.8.52,2.75,2.75,0,0,0,1,.17,2.7,2.7,0,0,0,.94-.17,2.49,2.49,0,0,0,.81-.52,2.17,2.17,0,0,0,.72-1.64,2.22,2.22,0,0,0-.72-1.67A2.57,2.57,0,0,0,137.33,130.63Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.31,128.89v.65a4.51,4.51,0,0,0-1.15-.62,4.37,4.37,0,0,0-1.5-.25,4.54,4.54,0,0,0-1.74.34,4.19,4.19,0,0,0-2.29,2.29,4.52,4.52,0,0,0,0,3.34,4.19,4.19,0,0,0,2.29,2.29,4.53,4.53,0,0,0,1.74.33h.18a4.62,4.62,0,0,0,1.75-.33v-2.32h0a2.49,2.49,0,0,1-.81.52,2.7,2.7,0,0,1-.94.17c-.14,0-.27,0-.4,0h0a3.53,3.53,0,0,1-.56-.14,2.22,2.22,0,0,1-.79-.52,2.17,2.17,0,0,1-.72-1.64,2.22,2.22,0,0,1,.72-1.67,2.47,2.47,0,0,1,.79-.5,2.6,2.6,0,0,1,1-.18,2.48,2.48,0,0,1,1.75.68,2.22,2.22,0,0,1,.72,1.67v4.28h2.06v-8.37Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M105.33,128.89h0v.64a4.69,4.69,0,0,0-1.15-.62,3.43,3.43,0,0,0-.75-.19,4.91,4.91,0,0,0-.88-.07,4.34,4.34,0,0,0-1.71.33,4,4,0,0,0-1.34.92,4.13,4.13,0,0,0-.86,1.37,4.44,4.44,0,0,0-.31,1.68h0a4.21,4.21,0,0,0,2.61,4,4.53,4.53,0,0,0,1.74.33H103a4.59,4.59,0,0,0,1.62-.33v-2.32h0a2.49,2.49,0,0,1-.81.52,2.7,2.7,0,0,1-.94.17c-.14,0-.27,0-.4,0h0a3.53,3.53,0,0,1-.56-.14,2.22,2.22,0,0,1-.79-.52,2.18,2.18,0,0,1-.72-1.65,2.28,2.28,0,0,1,.16-.87l0-.06a2.31,2.31,0,0,1,.53-.73,2.47,2.47,0,0,1,.79-.5,2.6,2.6,0,0,1,1-.18,2.48,2.48,0,0,1,1.75.68,2.28,2.28,0,0,1,.52.73l0,.06a2.3,2.3,0,0,1,.17.88v3.26a2.17,2.17,0,0,1-.72,1.64,2.38,2.38,0,0,1-1.75.7,2.46,2.46,0,0,1-1.24-.32l-1.49,1.4a4.6,4.6,0,0,0,2.73.88,4.61,4.61,0,0,0,3.2-1.27,4.12,4.12,0,0,0,1-1.37,3.94,3.94,0,0,0,.36-1.66V128.9h-2.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M73.38,144.35v.54H71v-3.11h2.3v.55H71.61v.79H73v.53H71.61v.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M77.33,141.52v3.33h-.62v-.14a1.42,1.42,0,0,1-.69.18,1.24,1.24,0,0,1,0-2.48,1.42,1.42,0,0,1,.69.18v-1.07Zm-.62,2.61v-1a.86.86,0,0,0-.58-.21.69.69,0,0,0-.72.69.68.68,0,0,0,.72.69A.86.86,0,0,0,76.71,144.13Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M81.26,142.46v2.4h-.61v-.16a1.22,1.22,0,0,1-.66.19c-.7,0-1-.32-1-1.1v-1.33h.61v1.33c0,.37.18.55.52.55a.85.85,0,0,0,.55-.19v-1.69Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M85.05,144.41a1.15,1.15,0,0,1-.93.48,1.24,1.24,0,1,1,0-2.48,1.15,1.15,0,0,1,.93.48l-.39.37a.65.65,0,0,0-.54-.29.69.69,0,1,0,0,1.37.65.65,0,0,0,.54-.29Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M89,142.46v2.4h-.62v-.18a1.28,1.28,0,0,1-.7.21,1.24,1.24,0,0,1,0-2.48,1.39,1.39,0,0,1,.7.2v-.15Zm-.62.71a1,1,0,0,0-.59-.2.68.68,0,0,0-.71.68.69.69,0,0,0,.71.69.9.9,0,0,0,.59-.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M91.4,143v.85c0,.42.07.55.38.55l.28,0v.46a2,2,0,0,1-.56.08.69.69,0,0,1-.72-.75V143h-.34v-.51h.34v-.94h.62v.94h.67V143Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.54,141.87a.36.36,0,0,1,.35-.36.36.36,0,0,1,.35.36.35.35,0,0,1-.35.36A.36.36,0,0,1,93.54,141.87Zm0,.62h.61v2.4h-.61Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M98.38,143.66a1.31,1.31,0,0,1-2.62,0,1.31,1.31,0,0,1,2.62,0Zm-.6,0a.71.71,0,1,0-.71.68A.7.7,0,0,0,97.78,143.66Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M102.21,143.55v1.34h-.61v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4h.62v.15a1.1,1.1,0,0,1,.64-.19C101.89,142.45,102.21,142.78,102.21,143.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M107,142.33v1.11h1.49V144H107v.91h-.62v-3.11h2.35v.55Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M112.74,143.66a1.31,1.31,0,1,1-1.31-1.25A1.27,1.27,0,0,1,112.74,143.66Zm-.6,0a.71.71,0,1,0-.71.68A.7.7,0,0,0,112.14,143.66Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M116.56,142.46v2.4h-.62v-.16a1.16,1.16,0,0,1-.65.19c-.7,0-1-.32-1-1.1v-1.33h.62v1.33c0,.37.18.55.52.55a.81.81,0,0,0,.54-.19v-1.69Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M120.5,143.55v1.34h-.61v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4h.62v.15a1.1,1.1,0,0,1,.64-.19C120.18,142.45,120.5,142.78,120.5,143.55Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M124.56,141.52v3.33h-.62v-.14a1.42,1.42,0,0,1-.69.18,1.24,1.24,0,0,1,0-2.48,1.42,1.42,0,0,1,.69.18v-1.07Zm-.62,2.61v-1a.86.86,0,0,0-.58-.21.69.69,0,0,0-.72.69.68.68,0,0,0,.72.69A.86.86,0,0,0,123.94,144.13Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M128.63,142.46v2.4H128v-.18a1.29,1.29,0,0,1-.71.21,1.24,1.24,0,0,1,0-2.48,1.43,1.43,0,0,1,.71.2v-.15Zm-.61.71a1,1,0,0,0-.6-.2.68.68,0,0,0-.71.68.69.69,0,0,0,.71.69.9.9,0,0,0,.6-.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M131,143v.85c0,.42.07.55.38.55l.29,0v.46a2,2,0,0,1-.56.08.69.69,0,0,1-.73-.75V143h-.34v-.51h.34v-.94H131v.94h.67V143Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M133.18,141.87a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm0,.62h.62v2.4h-.62Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138,143.66a1.32,1.32,0,1,1-1.31-1.25A1.27,1.27,0,0,1,138,143.66Zm-.61,0a.69.69,0,0,0-.7-.69.69.69,0,1,0,0,1.37A.69.69,0,0,0,137.42,143.66Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M141.86,143.55v1.34h-.62v-1.34c0-.37-.18-.55-.52-.55a.8.8,0,0,0-.53.19v1.7h-.61v-2.4h.61v.15a1.15,1.15,0,0,1,.64-.19C141.54,142.45,141.86,142.78,141.86,143.55Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M85.51,150.38v.55h-2.4V147.8h2.31v.55H83.73v.8h1.42v.53H83.73v.7Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M88.37,147.58v3.35h-.62v-.15a1.38,1.38,0,0,1-.7.19,1.21,1.21,0,0,1-1.22-1.25,1.19,1.19,0,0,1,1.22-1.24,1.49,1.49,0,0,1,.7.18v-1.08Zm-.62,2.62v-1a1,1,0,0,0-.59-.2.69.69,0,0,0-.72.69.68.68,0,0,0,.72.69A.9.9,0,0,0,87.75,150.2Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M91.2,148.52v2.41h-.62v-.16a1.18,1.18,0,0,1-.65.19c-.71,0-1-.32-1-1.1v-1.34h.61v1.34a.48.48,0,0,0,.53.55.81.81,0,0,0,.54-.19v-1.7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.89,150.48A1.15,1.15,0,0,1,93,151a1.24,1.24,0,1,1,0-2.48,1.17,1.17,0,0,1,.94.47l-.4.37A.67.67,0,0,0,93,149a.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M96.73,148.52v2.41h-.61v-.18a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.46,1.46,0,0,1,.71.2v-.15Zm-.61.72a.93.93,0,0,0-.6-.21.69.69,0,1,0,0,1.38,1,1,0,0,0,.6-.2Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M98,149v.85c0,.43.07.56.38.56a2.36,2.36,0,0,0,.29,0v.47a2,2,0,0,1-.56.08.69.69,0,0,1-.73-.75V149h-.34v-.51h.34v-.94H98v.94h.68V149Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M99.08,147.9a.36.36,0,1,1,.36.36A.36.36,0,0,1,99.08,147.9Zm0,.62h.62v2.41h-.62Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M102.84,149.72a1.32,1.32,0,1,1-1.32-1.24A1.28,1.28,0,0,1,102.84,149.72Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,102.23,149.72Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M105.57,149.58v1.35H105v-1.35c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.71h-.62v-2.41h.62v.15a1.12,1.12,0,0,1,.64-.19C105.25,148.48,105.57,148.8,105.57,149.58Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.22,149.54a6,6,0,0,1-.47.71l.37.37-.37.34-.35-.34a1.31,1.31,0,0,1-.83.34c-.71,0-1.18-.33-1.18-.91a.92.92,0,0,1,.66-.83.86.86,0,0,1-.27-.61.81.81,0,0,1,.87-.84.82.82,0,0,1,.9.78,1,1,0,0,1-.68.85l.54.51a4,4,0,0,0,.37-.51Zm-1.14.74-.7-.69c-.25.11-.37.26-.37.44s.21.44.59.44A.76.76,0,0,0,109.08,150.28Zm-.79-1.65a.62.62,0,0,0,.28.45c.19-.06.46-.21.46-.45a.38.38,0,0,0-.38-.42A.39.39,0,0,0,108.29,148.63Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M114.35,147.8H115l-1.46,3.13h-.29l-1.45-3.13h.68l.92,2Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M115.32,147.9a.36.36,0,1,1,.36.36A.36.36,0,0,1,115.32,147.9Zm.05.62H116v2.41h-.62Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M116.66,150.28a1.9,1.9,0,0,0,.83.19c.28,0,.39-.1.39-.23s-.14-.2-.51-.28c-.52-.11-.9-.28-.9-.75s.36-.73.92-.73a2.34,2.34,0,0,1,.94.19l-.2.45a2.23,2.23,0,0,0-.75-.15c-.24,0-.36.08-.36.21s.15.2.54.28c.56.11.88.31.88.75s-.35.75-1,.75a2,2,0,0,1-1-.23Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M121.29,148.52v2.41h-.61v-.18a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.46,1.46,0,0,1,.71.2v-.15Zm-.61.72a.93.93,0,0,0-.6-.21.69.69,0,1,0,0,1.38,1,1,0,0,0,.6-.2Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M125.69,150c0,.6-.49,1-1.21,1a2.38,2.38,0,0,1-1.3-.3l.23-.49a2.21,2.21,0,0,0,1.09.24c.34,0,.54-.13.54-.36s-.21-.3-.66-.41c-.65-.15-1.16-.33-1.16-.94s.43-.94,1.15-.94a3.14,3.14,0,0,1,1.2.25l-.26.5a2.88,2.88,0,0,0-1-.2c-.32,0-.5.14-.5.33s.22.32.69.42C125.23,149.23,125.69,149.44,125.69,150Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M126.65,149.9a.67.67,0,0,0,.68.54.76.76,0,0,0,.62-.3l.4.33a1.33,1.33,0,0,1-1.09.49,1.24,1.24,0,0,1,0-2.48,1.15,1.15,0,0,1,1.17,1.28v.14Zm0-.4h1.19a.53.53,0,0,0-.58-.53A.63.63,0,0,0,126.65,149.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M129.49,148.86a.91.91,0,0,1,.76-.38.36.36,0,0,1,.15,0v.67a1.89,1.89,0,0,0-.29,0,.58.58,0,0,0-.62.63v1.16h-.62v-2.41h.62Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M133.2,148.52l-1.15,2.41h-.29l-1.16-2.41h.65l.65,1.37.66-1.37Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M133.52,147.9a.36.36,0,1,1,.36.36A.36.36,0,0,1,133.52,147.9Zm0,.62h.62v2.41h-.62Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.89,150.48a1.14,1.14,0,0,1-.93.48,1.24,1.24,0,1,1,0-2.48,1.16,1.16,0,0,1,.94.47l-.4.37A.67.67,0,0,0,136,149a.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M137.75,149.9a.68.68,0,0,0,.69.54.78.78,0,0,0,.62-.3l.4.33a1.33,1.33,0,0,1-1.09.49,1.24,1.24,0,0,1,0-2.48,1.15,1.15,0,0,1,1.17,1.28v.14Zm0-.4H139a.53.53,0,0,0-.58-.53A.63.63,0,0,0,137.76,149.5Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M140.08,150.28a1.89,1.89,0,0,0,.82.19c.29,0,.4-.1.4-.23s-.14-.2-.51-.28-.9-.28-.9-.75.36-.73.92-.73a2.34,2.34,0,0,1,.94.19l-.2.45a2.23,2.23,0,0,0-.75-.15c-.24,0-.36.08-.36.21s.15.2.54.28c.55.11.88.31.88.75s-.35.75-1,.75a2,2,0,0,1-1-.23Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 425.32,
    x2: 0.13,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 425.32,
    x2: 293.71,
    y2: 425.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 20.37,
    x2: 293.71,
    y2: 20.37
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 384.83,
    x2: 293.71,
    y2: 384.83
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 344.33,
    x2: 293.71,
    y2: 344.33
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 303.84,
    x2: 293.71,
    y2: 303.84
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 263.34,
    x2: 293.71,
    y2: 263.34
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 222.85,
    x2: 293.71,
    y2: 222.85
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 182.35,
    x2: 293.71,
    y2: 182.35
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 141.86,
    x2: 293.71,
    y2: 141.86
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 101.36,
    x2: 293.71,
    y2: 101.36
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 60.87,
    x2: 293.71,
    y2: 60.87
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 405.07,
    x2: 293.71,
    y2: 405.07
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 364.58,
    x2: 293.71,
    y2: 364.58
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 324.08,
    x2: 293.71,
    y2: 324.08
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 283.59,
    x2: 293.71,
    y2: 283.59
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 243.09,
    x2: 293.71,
    y2: 243.09
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 202.6,
    x2: 293.71,
    y2: 202.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 162.1,
    x2: 293.71,
    y2: 162.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 121.61,
    x2: 293.71,
    y2: 121.61
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 81.11,
    x2: 293.71,
    y2: 81.11
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 40.62,
    x2: 293.71,
    y2: 40.62
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 283.59,
    y1: 425.32,
    x2: 283.59,
    y2: 0.13
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 243.1,
    y1: 425.32,
    x2: 243.1,
    y2: 0.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 202.6,
    y1: 425.32,
    x2: 202.6,
    y2: 0.13
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 162.11,
    y1: 425.32,
    x2: 162.11,
    y2: 0.13
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 121.61,
    y1: 425.32,
    x2: 121.61,
    y2: 0.13
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 81.12,
    y1: 425.32,
    x2: 81.12,
    y2: 0.13
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 40.62,
    y1: 425.32,
    x2: 40.62,
    y2: 0.13
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 263.34,
    y1: 425.32,
    x2: 263.34,
    y2: 0.13
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 222.85,
    y1: 425.32,
    x2: 222.85,
    y2: 0.13
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 182.35,
    y1: 425.32,
    x2: 182.35,
    y2: 0.13
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 141.86,
    y1: 425.32,
    x2: 141.86,
    y2: 0.13
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 101.36,
    y1: 425.32,
    x2: 101.36,
    y2: 0.13
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 60.87,
    y1: 425.32,
    x2: 60.87,
    y2: 0.13
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 20.37,
    y1: 425.32,
    x2: 20.37,
    y2: 0.13
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 0.13,
    y1: 0.13,
    x2: 293.71,
    y2: 0.13
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.13,
    y: 0.13,
    width: 293.59,
    height: 425.2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "470.58 236.28 470.58 236.28 323.78 324.08 323.78 425.32 617.37 425.32 617.37 324.08 470.58 236.28"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "translate(422.16 375.82)"
  }, "Suite 1001, ", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 31.3,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.33,
    y: 0
  }, "evel 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 50.01,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.75,
    y: 0
  }, ", 307 Pitt "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 80.05,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.71,
    y: 0
  }, "treet"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 7.86,
    y: 7.71
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.59,
    y: 7.71
  }, "ydney NSW 200"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 57.73,
    y: 7.71
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.46,
    y: 7.71
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 64.61,
    y: 7.71
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 68.76,
    y: 7.71
  }, "ustralia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 21.6,
    y: 15.43
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.94,
    y: 15.43
  }, ": +61-2-80605365"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.16,
    y: 23.14
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 24.59,
    y: 23.14
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 29.03,
    y: 23.14
  }, ".kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 68.19,
    y: 23.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 69.63,
    y: 23.14
  }, "com"))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M445.76,341l-1,.14a3.85,3.85,0,0,1-.49.11c-.38,0-.57-.48-1.1-.59-.13,0,0,0-.2-.06s.07,0-.25-.12c0,.34-.07.25-.07.52a2,2,0,0,0,.21.89c.1.2.14.13.13.41a1.82,1.82,0,0,0,.15,1.12,2.82,2.82,0,0,1,.39.8c.52,0,.45,0,.51.15.49,0,.17-.11.45-.15,0,0,.49.12.36-.51.37.1.2.3.44.27s.09-.18.13-.41-.1-.06.24-.22l-.07-.44c0-.52.12,0,.29.07l.22-1.55c0-.12.16-.07-.14-.51C445.64,340.93,445.84,340.94,445.76,341Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M445.9,339.64c0,.21.12.12-.14.14l.29.66c.13-.06.09-.05.29-.06,0-.46,0-.3-.15-.52S446.1,339.69,445.9,339.64Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M442.22,339.05c-.07.3,0,0-.09.24s-.13.65.31.42C442.44,339.19,442.49,339.23,442.22,339.05Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M436.55,333.84a2.82,2.82,0,0,0-.89.14c-.54.14-.31.26-.13.52a3.45,3.45,0,0,0,1.27-.18c.24-.05.26,0,.12-.26h-.37Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M451.45,330.23c0-.08,0-.16-.07-.25l-.84-.31c-.6-.22-1.19-.44-1.78-.68s-1.2-.49-1.87-.82-1.43-.72-2.17-1.18a4.86,4.86,0,0,1-1.78-2,6.38,6.38,0,0,1-.41-1h-.14a3.35,3.35,0,0,0-.8.11c-.26.05-.51.12-.77.19a9.94,9.94,0,0,1-2.05.39h-.27q-.39,0-.78,0a5.22,5.22,0,0,1-.58,0,9.26,9.26,0,0,1-1.23-.22l-.43-.09-.34.39a1.15,1.15,0,0,1,.23.21,1.5,1.5,0,0,1,.31,1.44,2.2,2.2,0,0,1-1.92,1.41l-.71,0h-.11a2.37,2.37,0,0,1-1.9-1.24,1.67,1.67,0,0,1,.14-1.84l0-.06c.09-.15.2-.31.3-.46a4.44,4.44,0,0,0,.35-.54l.19-.38a2.52,2.52,0,0,1-2.12-1.6,5.14,5.14,0,0,1-.33-1.54l-.21.06-.34.08a3.29,3.29,0,0,1-.29.32,1.89,1.89,0,0,1-1.31.61,1.61,1.61,0,0,1-.52-.08h-.08a1.71,1.71,0,0,1-1-.3,1.29,1.29,0,0,1-.56-.39,1.25,1.25,0,0,1-.24-1.09,4.54,4.54,0,0,1,.84-1.82c0-.06.08-.11.1-.15a1.8,1.8,0,0,1,.51-1,8.85,8.85,0,0,1,.67-.59l.18-.16c.1-.08.22-.19.37-.29a2.23,2.23,0,0,1,.35-1,4.16,4.16,0,0,1,1.21-1.19c.26-.16.51-.3.75-.43l.37-.21a3.87,3.87,0,0,0,.34-.21l.2-.12a1.12,1.12,0,0,1,.58-.17,1,1,0,0,1,.47.11,1.15,1.15,0,0,1,.64,1.33l-.37,1.28a3,3,0,0,1-.54,1,9.35,9.35,0,0,1,.79.54,4.51,4.51,0,0,1,.63.59h.48l.17,0a4.35,4.35,0,0,0,1.16-.53l.17-.1a10.23,10.23,0,0,1,2.28-1.09,15.54,15.54,0,0,1,4.07-.57h.54c.75,0,1.51,0,2.21.08a12.66,12.66,0,0,1,1.69.23,9.9,9.9,0,0,1,4.06,1.76.74.74,0,0,0-.4-.56c-.21-.1-.11,0-.26-.13s0,0,0,0l-.16-.13c-.26-.16-.22,0-.32-.36l-.09.06-.05,0c-.16,0-.11-.29-.26-.48s.07.14-.31-.05c-.21-.1,0,0-.12-.09a.33.33,0,0,0-.15-.07l-.13,0c-.61-.24-.5-.34-.5-.95-.52-.14-.2-.54-.17-.88.06-.54-.26-.6-.13-1.18-.73,0-.43-.73-.64-1.5l0-.71c0-.16,0,.06.08-.21l-.19-.1c-.69-.41-.55-.73-.76-.86l-.51.16c-.15.11,0,.08-.22.13-.49-.45-.26-1.4-.43-2-.06-.26-.11-.62-.46-.7a1.12,1.12,0,0,1,.22-.45c-.18-.08-.26-.06-.44-.15a2.14,2.14,0,0,0-.22-1.17c-.14-.24-.05-.26-.37-.29-.09.34-.06.14-.37.29a2,2,0,0,1-.27,1.13l0,0-.07.09a1.44,1.44,0,0,0-.3.72h.22c0,.34,0,.14-.16.35s-.09,0-.05.36-.26.41-.23.82.12.19.11.44-.07.22-.06.43c0,.55.23.41,0,.93s-.17,1.08-.5,1.63a7.59,7.59,0,0,0-.38.8,1,1,0,0,1-.83.32,3.43,3.43,0,0,1-.75-.36c-.14-.08-.25-.12-.31-.26s0-.1-.09-.22c-.17-.36-.66-.33-1-.46s-.47-.63-1.32-1l-.44-.14-.35-.24-.28-.31c-.08-.08-.23-.16-.34-.25l-.32-.19c-.29-.17-.25,0-.26-.41.17-.06.35-.36.49-.55s0,0,.09-.13l.06-.16s0,0,0-.05.11-.27.16-.36c-.31-.12,0,.05-.3-.08.12-.17.09-.07.15-.29.38-.18.29-.08.51,0,.45-.65.19-.24.28-.61s.31-.39.46-.63l-.27-.17c-.3-.16-.24.12-.24-.42a1.32,1.32,0,0,0-.59.44c-.08-.1-.08.15-.08-.22a1,1,0,0,1-.37.14c.22-.28.12,0,.23-.29a1.86,1.86,0,0,0-1,.37c-.19-.13-.3-.12-.37-.37-.37,0-.1.06-.43.15a1.88,1.88,0,0,0-.6-.3v-.14c-.39,0-.65.25-1-.13,0,0-.17-.27-.2-.31-.27.07-.15.07-.37.21,0-.17-.08-.25-.32-.41s0,0-.15-.05l-.41,0c-.06,0,.11,0-.22.07v.22c.28.07,0,0,.21.09l.05,0,0,0c.22.1.24,0,.59,0a1.72,1.72,0,0,1,.14.67l-.54.19-.05,0-.66.07c-.28,0-.18-.06-.29-.28l-.19.1-.19.11c-.21.16.11.06-.25.19-.13.06-.18,0-.33,0,0,.2,0,.19-.16.42s0,.22-.36.25c0,.53,0,.23.15.58l-.24.09c-.36.09-.19.09-.32.45s-.31.11-.47.79c.24.16.3.16.34.31a.63.63,0,0,1,0,.27c-.7-.05-.39.05-.65,0a2.88,2.88,0,0,0-.82-.13c0,.54,0,.17-.15.32l0,0-.11.17c0-.51.11-.15.14-.58-.62-.17-.6-.83-1.22-.94s0-.15-.54-.16c-.13.27-.06.32-.3.5.08-.34,0-.1,0-.21-.27.06-.16.07-.36.21-.05-.33-.09-.28-.37-.14.05.22,0,.16.21.22a.88.88,0,0,0-.15.44l-.43-.36c-.19.37,0,.24-.28.45l-.1.05c-.1.06-.12.09-.21.15.1.4.19.08.07.37-.25,0-.27.11-.44.33,0,0,0,0,0,0l-.06.06-.12.11c-.11.1-.24.14-.27.36a.65.65,0,0,0,.19.43c-.17.19-.14.12-.16.44l-.32-.11c-.34-.08-.16.18-.26-.11h-.37c0,.5-.18.38-.07.59s.27.19.44.44c-.18.07-.06.05-.29,0,0,.38.08.13,0,.51-.23-.16-.11-.12-.37-.59s-.27-.16-.23-.66c-.3.09-.28.24-.43.44l-.36.38a1.27,1.27,0,0,0-.29.58c0,.22.13.34.13.73,0,0,0,0,0,.05a.5.5,0,0,1,.19-.05c-.05.16,0,.08-.11.19a.5.5,0,0,1-.07.08c-.1.11,0,0-.11.1l-.12.1-.05,0-.08.07c-.19.15-.14.17-.23.36l0,.1c-.45,1.17-.72,1.17-2,1.66-.24.09,0,.06-.27.08s-.19-.17-.49,0-.06.17-.3.37-.42-.12-1.11.58a.59.59,0,0,1-.45.18c-.38,0-.1-.21-.59.11,0-.39.08-.14-.14-.23-.06.24-.05.2-.25.35-.44.33-.08-.1-.72.6l-.08.08-.23.28-.06.08c-.35.39-1.09.23-1.09,1.41h-.22a5.53,5.53,0,0,1-.08-.81,1.7,1.7,0,0,0-.51,1.31c.23.09.06-.12.19.19a1,1,0,0,1,0,.9,1.07,1.07,0,0,0-.14.4v.53c0,.17.06.12.23.32s.06.27.38.65l.05,0c.08.11.09.14.18.26.29.38.41.18.41,1.06h-.15a1.19,1.19,0,0,0-.81-1c0,.68.18.22.22.73-.17-.11-.07-.09-.29-.14,0,.38.07.13-.15.22.48.71,1.22,1,1.41,1.89.07.41.51.63.66,1s0,.05.12.24.14.13.22.22a1,1,0,0,1,.25.63c.25,1.55,1.19,1.88,1.29,2.81v.55c-.05.32,0,.27.12.59s0,.43-.11.68a1.33,1.33,0,0,1-.43-.07c0,.53,0,1,.45,1,.62,0,.84.75,1.85.58.32-.06.85,0,1.13-.14s.32-.35.43-.47l0,0,.11-.12.07-.07.21-.13c.18,0,.45,0,.52-.26,0,0,0-.12,0-.14.11-.41.69-.4,1.07-.53l.85-.12h.17c.27,0-.08,0,.19,0l.11,0,0,0c.26.12-.2.07.27.1.06-.16.15-.25.61-.24s.86.23,1.1-.76a.68.68,0,0,1,.14-.38c.18-.21.3-.12.59-.29,1.17-.68.71-.8,2-.82a3.93,3.93,0,0,0,1.41-.43c.87-.35.78-.59,2.12-.59a3.6,3.6,0,0,0,.85-.12c.32-.06,1,.46,1.22.62.42-.1.19-.3.71,0,.32.19.53.12.9.21.1.23,0,0,0,.37.24-.06.24-.1.44,0-.06.16-.14.1-.18.27l.15.42c.18.16.32,0,.51.22a6,6,0,0,0,.39.65,1.26,1.26,0,0,1,.24.71h-.11l-.19.2c.45,0,.33.32.73.42a.4.4,0,0,1,.15,0s0,0,.15.06l-.05-.29c-.06-.22,0-.29.43-.79s.78-.35,1-.73a2.17,2.17,0,0,1,.33-.55c.18-.19.05.08.16-.2,0,.05,0,0,0,0s0,0,.07.09l.12.17c-.22,0-.19,0-.29.14.15.33.16.29,0,.5a1.67,1.67,0,0,0-.37,1.15c0,.43-.1.33-.51.33-.07.27-.12.21-.15.52a1.8,1.8,0,0,0,.52-.15c.31-.08.34.17.52-.22l.29-.88.14.23s0,0,0,.05l0,.1a.05.05,0,0,1,0,0c.41.83-.27.85-.32,1.34a2.56,2.56,0,0,0,.74-.14s0,0,0,0,0,0,0,0c.46.39.95.9.74,1.57v0l0,.36a1.14,1.14,0,0,0,.31.47l.3.49c.23.25.57.14.83.44l.2.23c.22-.07.22-.16.45-.09l.16.06.06,0c.2.06.1,0,.28.09a3,3,0,0,1,.82.58c.41,0,1.2-1.05,1.39-.29.37,0,.38-.26.67-.29l-.05.1c-.1.21-.06-.13-.1.27l.35.31.1.11.23.08a.55.55,0,0,1,.13.3.36.36,0,0,0,.22-.51c.86,0,1.11-.87,2-.83.6,0,1.06.2,1.49-.14l.16-.21c.1-.26,0-.32,0-.55l.39-1.07a1.43,1.43,0,0,1,.78-.95c.21-.18.05-.05.07-.19v-.05l.05-.2a1.39,1.39,0,0,1,.4-.7c.43-.35.25-.6.89-1.3l.43-.24.05,0,.15-.11C451.64,331.25,451.55,330.74,451.45,330.23Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M419.07,313.13Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M432.62,317.84a8.43,8.43,0,0,0-.74-.73c-.36-.27-.75-.51-1.13-.74a2.39,2.39,0,0,0-.58-.22,1.09,1.09,0,0,0-.36,0,2.4,2.4,0,0,1,.62-.69,2.25,2.25,0,0,0,.81-1.09c.12-.43.24-.85.37-1.28l-.05,0-.56.35c-.36.2-.73.39-1.07.61a3,3,0,0,0-.89.86,1.27,1.27,0,0,0-.18.89c0,.22-.1.22-.1.22a1.57,1.57,0,0,0-.65.39c-.26.23-.54.45-.78.7a.62.62,0,0,0-.2.39,1.16,1.16,0,0,1-.31.66,3.77,3.77,0,0,0-.65,1.39c0,.18.05.25.24.22a.52.52,0,0,0,.59.22s.06,0,.08,0c.38.19.56.16.92-.18a1.68,1.68,0,0,0,.24-.29c.18-.26.47-.28.74-.36a2,2,0,0,0,.9-.36s.21-.17.3-.05a2.74,2.74,0,0,1,.36.48,2.33,2.33,0,0,1,.17.69,4.09,4.09,0,0,0,.26,1.34,1.44,1.44,0,0,0,1.68.89,3,3,0,0,1,1.45,0l.28.13-.54-.05a.15.15,0,0,0-.18.11c-.26.61-.51,1.22-.8,1.8-.2.38-.47.72-.7,1.08s-.34.48-.17.74a1.26,1.26,0,0,0,1,.71c.25,0,.5,0,.75,0a1.18,1.18,0,0,0,.87-.64.41.41,0,0,0-.11-.41.37.37,0,0,1-.38.23.86.86,0,0,0-.24.11c0-.17.15-.16.29-.21l0-.32c-.05,0-.08,0-.09.06a.35.35,0,0,1-.49.16l-.2-.06c-.22-.07-.26-.05-.28.17a1,1,0,0,1,0,.16.45.45,0,0,1,.05-.58c.27-.34.55-.68.85-1a11.42,11.42,0,0,0,1.73-2.31,1.52,1.52,0,0,0,.16-.42.84.84,0,0,0-.4-.87,8.51,8.51,0,0,0-1-.62.72.72,0,0,1-.44-.86l.09.28c.08.26.33.34.53.45s.69.33,1,.51a1,1,0,0,1,.33,1.63c-.18.28-.36.57-.53.86-.06.1-.07.17.1.2.59.1,1.17.27,1.76.34a8.78,8.78,0,0,0,1.45,0,15.55,15.55,0,0,0,2.63-.55,3.73,3.73,0,0,1,1.56-.09l.1,0-.09-.83-.06-.68a5.48,5.48,0,0,0-.55-2.25c-.06-.11-.15-.22-.23-.35a1.36,1.36,0,0,1,.5.45,2.54,2.54,0,0,1,.41,1.12c.13.67.22,1.35.34,2a7.24,7.24,0,0,0,.61,2.12,3.84,3.84,0,0,0,1.38,1.58,23.19,23.19,0,0,0,2.08,1.13c.58.29,1.18.55,1.79.79s1.51.58,2.27.86l1.1.4a.68.68,0,0,1,.44.42l-.6-.31,0,.05a6.52,6.52,0,0,1,.18.63c.11.57.21,1.14.31,1.71s.15.9.21,1.34c0,.25,0,.5,0,.75a1.61,1.61,0,0,0,.35,1c.07.08.16.14.24.22a7.41,7.41,0,0,1,1.27,1.57,1.36,1.36,0,0,0,.45.41h.36s0-.08,0-.1a.44.44,0,0,1,0-.57,1.4,1.4,0,0,0,.16-.4c.05-.24-.11-.41-.23-.59l-.15-.17-.3.39,0,0a.7.7,0,0,0,.1-.79,1.22,1.22,0,0,0-.49-.67,1.17,1.17,0,0,1-.57-1c-.08-.51-.13-1-.18-1.54a5.58,5.58,0,0,1-.07-.91c0-.43.09-.86.12-1.3a1,1,0,0,0-.26-.71,6.55,6.55,0,0,0-1.2-.89c-.76-.52-1.52-1-2.24-1.62a10.34,10.34,0,0,1-2.46-2.81,3.41,3.41,0,0,1-.42-1.26,2.08,2.08,0,0,1,.14-1.05,4.56,4.56,0,0,0,.25,1.83c.39-.1.75-.25.81-.68a2.63,2.63,0,0,0-.05-.79c0-.24.09-.38.33-.33a1.25,1.25,0,0,1,.76.58c.6.9,1.18,1.82,1.77,2.73.35.55.7,1.11,1.07,1.66q.75,1.09,1.53,2.16a13.58,13.58,0,0,0,.93,1.08c.29.31.6.61.91.9a11,11,0,0,0,2,1.5,11.3,11.3,0,0,0,2.83,1.23,19,19,0,0,0,2.09.46,9.46,9.46,0,0,0,1.76.11,13.08,13.08,0,0,0,1.87-.23,10.51,10.51,0,0,0,2.78-.95c.43-.22.83-.5,1.24-.75a.12.12,0,0,0,.07-.07,2.89,2.89,0,0,0,0-.29.67.67,0,0,0-.24,0c-.22.08-.44.18-.65.28a13.12,13.12,0,0,1-2.37.85,11.29,11.29,0,0,1-1.64.31,12.28,12.28,0,0,1-1.82,0,7.58,7.58,0,0,1-3.12-.89,9.29,9.29,0,0,1-2.1-1.46c-.24-.22-.48-.44-.7-.67a15.54,15.54,0,0,1-1.67-2,30.23,30.23,0,0,1-1.76-2.9l-1.17-2.16a21,21,0,0,0-1.92-3,12.7,12.7,0,0,0-1.51-1.6,8.69,8.69,0,0,0-4.17-2,13.41,13.41,0,0,0-1.55-.2,26.05,26.05,0,0,0-2.65-.07,14.6,14.6,0,0,0-3.78.52,10.53,10.53,0,0,0-2.21,1.08,4.85,4.85,0,0,1-1.49.66,1.84,1.84,0,0,1-.4.06,5.26,5.26,0,0,0-.89,0Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M529.15,306.21h-.59v1.68h-.35v-1.68h-.6v-.35h1.54Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M531.32,305.86v2H531v-1.44l-.66,1-.67-1v1.44h-.35v-2h.38l.64,1,.63-1Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M475.79,311.11v.65a4.64,4.64,0,0,0-1.15-.61,4,4,0,0,0-1.49-.25,4.32,4.32,0,0,0-1.74.34,4.07,4.07,0,0,0-1.38.92,4.16,4.16,0,0,0-.91,1.37,4.29,4.29,0,0,0,2.29,5.63,4.49,4.49,0,0,0,1.74.33h.17a4.67,4.67,0,0,0,1.76-.33v-2.32h0a2.37,2.37,0,0,1-.8.51,2.5,2.5,0,0,1-.95.17,2.69,2.69,0,0,1-.4,0h0a2.12,2.12,0,0,1-.55-.14,2.37,2.37,0,0,1-1.52-2.16,2.21,2.21,0,0,1,.72-1.66,2.46,2.46,0,0,1,.8-.5,2.55,2.55,0,0,1,.95-.18,2.46,2.46,0,0,1,1.75.68,2.21,2.21,0,0,1,.72,1.66v4.29h2.06v-8.38Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M467.08,319.49l-4.57-4.4v4.4h-2.06v-11.6h2.06v4.38l4.57-4.37H470l-6,5.78,6,5.81Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M483.21,310.9a3.72,3.72,0,0,1,1.52.3,3.55,3.55,0,0,1,1.18.83,3.7,3.7,0,0,1,.75,1.23,4.16,4.16,0,0,1,.27,1.5v4.73h-2.06v-4.73a1.74,1.74,0,0,0-.6-1.35,2.1,2.1,0,0,0-2.83,0,1.79,1.79,0,0,0-.58,1.35v4.73H478.8v-8.36h2.06v.62a4.12,4.12,0,0,1,1-.61A3.43,3.43,0,0,1,483.21,310.9Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M511.12,311.13a3.69,3.69,0,0,1,1.38-.25v2a2.43,2.43,0,0,0-1.75.69,2.26,2.26,0,0,0-.72,1.66v4.3H508v-8.38H510v.64A4.29,4.29,0,0,1,511.12,311.13Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M517.16,310.9a4.52,4.52,0,0,1,1.76.34,4.33,4.33,0,0,1,1.44.92,4,4,0,0,1,1,1.37,4.05,4.05,0,0,1,0,3.34,4.08,4.08,0,0,1-1,1.36,4.52,4.52,0,0,1-1.44.93,4.89,4.89,0,0,1-3.53,0,4.52,4.52,0,0,1-1.44-.93,4.08,4.08,0,0,1-1-1.36,4.16,4.16,0,0,1,0-3.34,4,4,0,0,1,1-1.37,4.33,4.33,0,0,1,1.44-.92A4.54,4.54,0,0,1,517.16,310.9Zm0,2a2.46,2.46,0,0,0-1.75.68,2.24,2.24,0,0,0,0,3.31,2.07,2.07,0,0,0,.79.51,2.59,2.59,0,0,0,1,.17,2.49,2.49,0,0,0,.94-.17,2.31,2.31,0,0,0,.81-.51,2.26,2.26,0,0,0,0-3.31A2.57,2.57,0,0,0,517.16,312.86Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M526.79,310.9a4.54,4.54,0,0,1,1.77.34,4.41,4.41,0,0,1,2.41,2.29,4.16,4.16,0,0,1,0,3.34,4.39,4.39,0,0,1-1,1.36,4.52,4.52,0,0,1-1.44.93,4.91,4.91,0,0,1-3.54,0,4.52,4.52,0,0,1-1.44-.93,4.39,4.39,0,0,1-1-1.36,4.16,4.16,0,0,1,0-3.34,4.41,4.41,0,0,1,2.41-2.29A4.54,4.54,0,0,1,526.79,310.9Zm0,2a2.46,2.46,0,0,0-1.75.68,2.26,2.26,0,0,0,0,3.31,2.11,2.11,0,0,0,.8.51,2.54,2.54,0,0,0,.95.17,2.45,2.45,0,0,0,.94-.17,2.31,2.31,0,0,0,.81-.51,2.26,2.26,0,0,0,0-3.31A2.55,2.55,0,0,0,526.79,312.86Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M504.77,311.11v.65a4.82,4.82,0,0,0-1.15-.61,4.08,4.08,0,0,0-1.49-.25,4.4,4.4,0,0,0-1.75.34,4.07,4.07,0,0,0-1.38.92,4.16,4.16,0,0,0-.91,1.37,4.52,4.52,0,0,0,0,3.34,4.28,4.28,0,0,0,2.29,2.29,4.58,4.58,0,0,0,1.75.33h.17a4.71,4.71,0,0,0,1.76-.33v-2.32h0a2.31,2.31,0,0,1-.81.51,2.49,2.49,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2.39,2.39,0,0,1-1.35-.65,2.26,2.26,0,0,1,0-3.31,2.36,2.36,0,0,1,.8-.5,2.55,2.55,0,0,1,.95-.18,2.48,2.48,0,0,1,1.75.68,2.21,2.21,0,0,1,.72,1.66v4.29h2.06v-8.38Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M494.79,311.11v.65a4.82,4.82,0,0,0-1.15-.61,3.43,3.43,0,0,0-.75-.19,4.88,4.88,0,0,0-.88-.08,4.35,4.35,0,0,0-1.71.34,4,4,0,0,0-1.34.92,4.13,4.13,0,0,0-.86,1.37,4.44,4.44,0,0,0-.31,1.68h0a4.47,4.47,0,0,0,.32,1.67,4.28,4.28,0,0,0,2.29,2.29,4.58,4.58,0,0,0,1.75.33h.3a4.68,4.68,0,0,0,1.63-.32v-2.32h0a2.31,2.31,0,0,1-.81.51,2.49,2.49,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2,2,0,0,1-.55-.14,2.11,2.11,0,0,1-.8-.51,2.19,2.19,0,0,1-.72-1.65,2.25,2.25,0,0,1,.17-.87l0-.07a2.38,2.38,0,0,1,1.32-1.22,2.55,2.55,0,0,1,.95-.18,2.48,2.48,0,0,1,1.75.68,2.35,2.35,0,0,1,.52.72l0,.07a2.29,2.29,0,0,1,.17.87v3.26a2.21,2.21,0,0,1-.72,1.65,2.52,2.52,0,0,1-3,.37l-1.49,1.4a4.43,4.43,0,0,0,2.73.88,4.54,4.54,0,0,0,1.77-.34,5,5,0,0,0,1.44-.93,4.39,4.39,0,0,0,1-1.36,4.13,4.13,0,0,0,.35-1.67v-7.35Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M462.85,326.57v.55h-2.4V324h2.3v.55h-1.68v.79h1.41v.53h-1.41v.7Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M466.8,323.75v3.33h-.62v-.14a1.49,1.49,0,0,1-.7.18,1.24,1.24,0,0,1,0-2.48,1.49,1.49,0,0,1,.7.18v-1.07Zm-.62,2.61v-1a1,1,0,0,0-.59-.2.69.69,0,0,0-.72.69.67.67,0,0,0,.72.68A1,1,0,0,0,466.18,326.36Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M470.72,324.68v2.41h-.61v-.16a1.19,1.19,0,0,1-.66.19c-.7,0-1-.33-1-1.1v-1.34H469V326c0,.37.18.55.52.55a.81.81,0,0,0,.55-.19v-1.7Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M474.51,326.64a1.15,1.15,0,0,1-.93.48,1.24,1.24,0,1,1,0-2.48,1.18,1.18,0,0,1,.94.48l-.4.37a.66.66,0,0,0-.54-.3.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M478.45,324.68v2.41h-.62v-.18a1.26,1.26,0,0,1-.7.21,1.24,1.24,0,0,1,0-2.48,1.39,1.39,0,0,1,.7.2v-.16Zm-.62.72a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.38.93.93,0,0,0,.59-.2Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M480.86,325.19V326c0,.43.07.56.38.56a2.19,2.19,0,0,0,.28,0V327a1.42,1.42,0,0,1-.56.09.69.69,0,0,1-.72-.75v-1.18h-.34v-.51h.34v-.93h.62v.93h.67v.51Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M483,324.1a.36.36,0,0,1,.35-.36.36.36,0,0,1,0,.72A.36.36,0,0,1,483,324.1Zm.05.62h.61v2.4h-.61Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M487.85,325.88a1.32,1.32,0,1,1-1.32-1.24A1.28,1.28,0,0,1,487.85,325.88Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,487.24,325.88Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M491.68,325.78v1.34h-.62v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4H490v.15a1.12,1.12,0,0,1,.64-.19C491.35,324.68,491.68,325,491.68,325.78Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M496.5,324.55v1.11H498v.55H496.5v.91h-.61V324h2.34v.55Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M502.2,325.88a1.31,1.31,0,1,1-1.31-1.24A1.27,1.27,0,0,1,502.2,325.88Zm-.6,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,501.6,325.88Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M506,324.68v2.41h-.61v-.16a1.22,1.22,0,0,1-.66.19c-.7,0-1-.33-1-1.1v-1.34h.61V326c0,.37.18.55.52.55a.85.85,0,0,0,.55-.19v-1.7Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M510,325.78v1.34h-.62v-1.34c0-.37-.18-.55-.52-.55a.78.78,0,0,0-.53.19v1.7h-.62v-2.4h.62v.15a1.15,1.15,0,0,1,.64-.19C509.64,324.68,510,325,510,325.78Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M514,323.75v3.33h-.61v-.14a1.49,1.49,0,0,1-.7.18,1.24,1.24,0,0,1,0-2.48,1.49,1.49,0,0,1,.7.18v-1.07Zm-.61,2.61v-1a1,1,0,0,0-.59-.2.69.69,0,0,0-.72.69.67.67,0,0,0,.72.68A1,1,0,0,0,513.41,326.36Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M518.09,324.68v2.41h-.61v-.18a1.28,1.28,0,0,1-.7.21,1.24,1.24,0,0,1,0-2.48,1.39,1.39,0,0,1,.7.2v-.16Zm-.61.72a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.38,1,1,0,0,0,.59-.2Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M520.5,325.19V326c0,.43.07.56.38.56a2.36,2.36,0,0,0,.29,0V327a1.54,1.54,0,0,1-.56.09.69.69,0,0,1-.73-.75v-1.18h-.34v-.51h.34v-.93h.62v.93h.68v.51Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M522.64,324.1a.36.36,0,1,1,.36.36A.36.36,0,0,1,522.64,324.1Zm.05.62h.62v2.4h-.62Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M527.49,325.88a1.32,1.32,0,1,1-1.31-1.24A1.28,1.28,0,0,1,527.49,325.88Zm-.61,0a.69.69,0,0,0-.7-.69.69.69,0,1,0,0,1.38A.69.69,0,0,0,526.88,325.88Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M531.32,325.78v1.34h-.61v-1.34a.48.48,0,0,0-.53-.55.8.8,0,0,0-.53.19v1.7H529v-2.4h.61v.15a1.15,1.15,0,0,1,.64-.19C531,324.68,531.32,325,531.32,325.78Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M475,332.61v.55h-2.4V330h2.3v.55h-1.69v.79h1.42v.54h-1.42v.7Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M477.83,329.81v3.35h-.62V333a1.49,1.49,0,0,1-.7.19,1.25,1.25,0,0,1,0-2.5,1.45,1.45,0,0,1,.7.18v-1.07Zm-.62,2.62v-1a1,1,0,0,0-.59-.2.69.69,0,1,0,0,1.38A.9.9,0,0,0,477.21,332.43Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M480.66,330.75v2.41H480V333a1.16,1.16,0,0,1-.65.19c-.71,0-1-.33-1-1.11v-1.33H479v1.33c0,.38.18.56.52.56a.81.81,0,0,0,.54-.19v-1.7Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M483.35,332.71a1.15,1.15,0,0,1-.93.48,1.25,1.25,0,1,1,0-2.49,1.17,1.17,0,0,1,.94.48l-.4.37a.65.65,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M486.2,330.75v2.41h-.62V333a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.43,1.43,0,0,1,.71.2v-.15Zm-.62.72a.93.93,0,0,0-.6-.21.69.69,0,1,0,0,1.38.91.91,0,0,0,.6-.21Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M487.51,331.26v.85c0,.43.07.55.38.55l.28,0v.46a1.48,1.48,0,0,1-.56.09.7.7,0,0,1-.73-.76v-1.17h-.34v-.51h.34v-.94h.63v.94h.67v.51Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M488.54,330.13a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm0,.62h.62v2.41h-.62Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M492.3,332A1.32,1.32,0,1,1,491,330.7,1.28,1.28,0,0,1,492.3,332Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,491.69,332Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M495,331.81v1.35h-.62v-1.35c0-.37-.18-.55-.52-.55a.78.78,0,0,0-.53.19v1.71h-.62v-2.41h.62v.15a1.08,1.08,0,0,1,.64-.2C494.71,330.7,495,331,495,331.81Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M499.68,331.77a6,6,0,0,1-.47.71l.37.37-.37.34-.34-.34a1.41,1.41,0,0,1-.83.34c-.72,0-1.18-.34-1.18-.91a1,1,0,0,1,.65-.84.87.87,0,1,1,1.5-.67,1,1,0,0,1-.68.86l.54.51a4,4,0,0,0,.37-.51Zm-1.14.73-.69-.68c-.26.1-.38.26-.38.44s.22.43.59.43A.71.71,0,0,0,498.54,332.5Zm-.79-1.64a.62.62,0,0,0,.28.45c.2-.07.46-.21.46-.46a.37.37,0,0,0-.37-.41A.39.39,0,0,0,497.75,330.86Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M503.81,330h.7l-1.46,3.13h-.3L501.3,330H502l.91,2Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M504.78,330.13a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm.05.62h.62v2.41h-.62Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M506.12,332.5a1.94,1.94,0,0,0,.83.2c.28,0,.39-.11.39-.23s-.14-.2-.51-.28-.89-.28-.89-.75.36-.74.91-.74a2.33,2.33,0,0,1,.94.2l-.2.45a2.18,2.18,0,0,0-.75-.15c-.23,0-.35.08-.35.21s.14.19.53.27c.56.12.88.31.88.75s-.35.76-1,.76a2.17,2.17,0,0,1-1-.23Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M510.75,330.75v2.41h-.61V333a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.43,1.43,0,0,1,.71.2v-.15Zm-.61.72a.93.93,0,0,0-.6-.21.68.68,0,0,0-.71.68.69.69,0,0,0,.71.7.91.91,0,0,0,.6-.21Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M515.15,332.24c0,.6-.49,1-1.21,1a2.38,2.38,0,0,1-1.3-.3l.23-.49a2.21,2.21,0,0,0,1.09.24c.34,0,.54-.13.54-.36s-.2-.31-.66-.41c-.64-.15-1.16-.33-1.16-.95s.44-.94,1.15-.94a2.92,2.92,0,0,1,1.2.26l-.26.5a2.85,2.85,0,0,0-.95-.21c-.32,0-.5.15-.5.34s.22.32.69.42C514.69,331.45,515.15,331.67,515.15,332.24Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M516.11,332.13a.66.66,0,0,0,.69.53.78.78,0,0,0,.62-.29l.39.32a1.31,1.31,0,0,1-1.09.5,1.25,1.25,0,0,1,0-2.49A1.17,1.17,0,0,1,517.9,332c0,.05,0,.1,0,.14Zm0-.4h1.2a.54.54,0,0,0-.59-.53A.62.62,0,0,0,516.11,331.73Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M519,331.08a.93.93,0,0,1,.76-.38.44.44,0,0,1,.15,0v.67a1.6,1.6,0,0,0-.3,0,.58.58,0,0,0-.61.63v1.17h-.62v-2.41H519Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M522.67,330.75l-1.16,2.41h-.29l-1.16-2.41h.65l.66,1.36.65-1.36Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M523,330.13a.36.36,0,1,1,.71,0,.36.36,0,1,1-.71,0Zm0,.62h.62v2.41H523Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M526.35,332.71a1.12,1.12,0,0,1-.93.48,1.25,1.25,0,1,1,0-2.49,1.16,1.16,0,0,1,.94.48l-.4.37a.65.65,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M527.22,332.13a.66.66,0,0,0,.68.53.76.76,0,0,0,.62-.29l.4.32a1.31,1.31,0,0,1-1.09.5,1.25,1.25,0,0,1,0-2.49A1.16,1.16,0,0,1,529,332v.14Zm0-.4h1.19a.53.53,0,0,0-.58-.53A.62.62,0,0,0,527.22,331.73Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M529.54,332.5a1.94,1.94,0,0,0,.83.2c.28,0,.39-.11.39-.23s-.14-.2-.51-.28-.89-.28-.89-.75.35-.74.91-.74a2.33,2.33,0,0,1,.94.2l-.2.45a2.23,2.23,0,0,0-.75-.15c-.24,0-.35.08-.35.21s.14.19.53.27c.56.12.88.31.88.75s-.35.76-1,.76a2.17,2.17,0,0,1-1-.23Z"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 425.32,
    x2: 323.78,
    y2: 0.13
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 425.32,
    x2: 617.37,
    y2: 425.32
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 20.37,
    x2: 617.37,
    y2: 20.37
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 384.83,
    x2: 617.37,
    y2: 384.83
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 344.33,
    x2: 617.37,
    y2: 344.33
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 303.84,
    x2: 617.37,
    y2: 303.84
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 263.34,
    x2: 617.37,
    y2: 263.34
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 222.85,
    x2: 617.37,
    y2: 222.85
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 182.35,
    x2: 617.37,
    y2: 182.35
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 141.86,
    x2: 617.37,
    y2: 141.86
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 101.36,
    x2: 617.37,
    y2: 101.36
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 60.87,
    x2: 617.37,
    y2: 60.87
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 405.07,
    x2: 617.37,
    y2: 405.07
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 364.58,
    x2: 617.37,
    y2: 364.58
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 324.08,
    x2: 617.37,
    y2: 324.08
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 283.59,
    x2: 617.37,
    y2: 283.59
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 243.09,
    x2: 617.37,
    y2: 243.09
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 202.6,
    x2: 617.37,
    y2: 202.6
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 162.1,
    x2: 617.37,
    y2: 162.1
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 121.61,
    x2: 617.37,
    y2: 121.61
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 81.11,
    x2: 617.37,
    y2: 81.11
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 40.62,
    x2: 617.37,
    y2: 40.62
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 607.25,
    y1: 425.32,
    x2: 607.25,
    y2: 0.13
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 566.75,
    y1: 425.32,
    x2: 566.75,
    y2: 0.13
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 526.26,
    y1: 425.32,
    x2: 526.26,
    y2: 0.13
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 485.76,
    y1: 425.32,
    x2: 485.76,
    y2: 0.13
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 445.27,
    y1: 425.32,
    x2: 445.27,
    y2: 0.13
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 404.77,
    y1: 425.32,
    x2: 404.77,
    y2: 0.13
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 364.28,
    y1: 425.32,
    x2: 364.28,
    y2: 0.13
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 587,
    y1: 425.32,
    x2: 587,
    y2: 0.13
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 546.51,
    y1: 425.32,
    x2: 546.51,
    y2: 0.13
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 506.01,
    y1: 425.32,
    x2: 506.01,
    y2: 0.13
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 465.52,
    y1: 425.32,
    x2: 465.52,
    y2: 0.13
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 425.02,
    y1: 425.32,
    x2: 425.02,
    y2: 0.13
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 384.53,
    y1: 425.32,
    x2: 384.53,
    y2: 0.13
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 344.03,
    y1: 425.32,
    x2: 344.03,
    y2: 0.13
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 323.78,
    y1: 0.13,
    x2: 617.37,
    y2: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 323.71,
    y: 0.13,
    width: 293.59,
    height: 425.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial12);
export default __webpack_public_path__ + "static/media/guideMaterial12.ba1f91fe8609adbd4b909ad8e97caa77.svg";
export { ForwardRef as ReactComponent };